module.exports={clientWsURL:"wss://classroom.grotto-networking.com/myws",wsServer:"localhost",wsPort:21146};